import { APIService } from "@/service/api.js";
import urlConstant from "@/constants/uri.constants.js";

const state = {
  registerResponse: {},
  registerOTPResponse: {},
  loginResponse: {},
  loginOTPResponse: {},
  autoLoginResponse: {},
};

const mutations = {
  registerEmployer(state, payload) {
    switch (payload.type) {
      case "REGISTERING_EMPLOYER":
        state.registerResponse = {
          isRegistering: true,
          errorRegistering: false,
          responseData: {},
        };
        break;
      case "REGISTERED_EMPLOYER":
        state.registerResponse = {
          isRegistering: false,
          errorRegistering: false,
          responseData: payload.data,
        };
        break;
    }
  },

  verifyRegisterOTP(state, payload) {
    switch (payload.type) {
      case "VERIFYING_OTP":
        state.registerOTPResponse = {
          isverifying: true,
          errorVerify: false,
          responseData: {},
        };
        break;
      case "VERIFIED_OTP":
        state.registerOTPResponse = {
          isverifying: false,
          errorVerify: false,
          responseData: payload.data,
        };
        break;
    }
  },

  loginEmployer(state, payload) {
    switch (payload.type) {
      case "LOGING_EMPLOYER":
        state.loginResponse = {
          isLoging: true,
          errorLoging: false,
          responseData: {},
        };
        break;
      case "LOGEDIN_EMPLOYER":
        state.loginResponse = {
          isLoging: false,
          errorLoging: false,
          responseData: payload.data,
        };
        break;
    }
  },
  verifyLoginOTP(state, payload) {
    switch (payload.type) {
      case "VERIFYING_LOGIN_OTP":
        state.loginOTPResponse = {
          isverifyingLoginOTP: true,
          errorVerify: false,
          responseData: {},
        };
        break;
      case "VERIFIED_LOGIN_OTP":
        state.loginOTPResponse = {
          isverifyingLoginOTP: false,
          errorVerify: false,
          responseData: payload.data,
        };
        break;
    }
  },
  ConvertToPaidLogin(state, payload) {
    switch (payload.type) {
      case "LOGING_TO_PAID":
        state.autoLoginResponse = {
          isLoging: true,
          errorLogging: false,
          responseData: {},
        };
        break;
      case "LOGED_IN_TO_PAID":
        state.autoLoginResponse = {
          isLoging: false,
          errorLogging: false,
          responseData: payload.data,
        };
        break;
    }
  },
};

const actions = {
  actionConvertToPaidLogin({ commit }, _obj) {
    commit("ConvertToPaidLogin", { type: "LOGING_TO_PAID" });
    APIService.post(urlConstant.baseUrl + urlConstant.convertToPaidLogin, _obj)
      .then((res) => {
        if (res.data) {
          // console.log('hhjhjhhjhjhjhjh',res.data);
          commit("ConvertToPaidLogin", {
            type: "LOGED_IN_TO_PAID",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("ConvertToPaidLogin", err);
      });
  },

  actionRegisterEmployer({ commit }, _employerDetails) {
    commit("registerEmployer", { type: "REGISTERING_EMPLOYER" });
    APIService.post(
      urlConstant.baseUrl + urlConstant.employerRegister,
      _employerDetails
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit("registerEmployer", {
            type: "REGISTERED_EMPLOYER",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("createTopic", err);
      });
  },

  actionVerifyOTP({ commit }, _otpDetails) {
    commit("verifyRegisterOTP", { type: "VERIFYING_OTP" });
    APIService.post(
      urlConstant.baseUrl + urlConstant.otpRegistrationVerify,
      _otpDetails
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit("verifyRegisterOTP", { type: "VERIFIED_OTP", data: res.data });
        }
      })
      .catch((err) => {
        console.log("createTopic", err);
      });
  },

  actionLoginEmployer({ commit }, _loginObj) {
    commit("loginEmployer", { type: "LOGING_EMPLOYER" });
    APIService.post(urlConstant.baseUrl + urlConstant.employerLogin, _loginObj)
      .then((res) => {
        if (res.data) {
          // console.log("actionLoginEmployer");

          commit("loginEmployer", { type: "LOGEDIN_EMPLOYER", data: res.data });
        }
      })
      .catch((err) => {
        console.log("createTopic", err);
      });
  },

  actionVerifyLoginOTP({ commit }, _otpDetails) {
    commit("verifyLoginOTP", { type: "VERIFYING_LOGIN_OTP" });
    APIService.post(
      `${urlConstant.baseUrl}${urlConstant.otpLoginVerify}`,
      _otpDetails
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit("verifyLoginOTP", {
            type: "VERIFIED_LOGIN_OTP",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("createTopic", err);
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
